/* GiftInOne 2.14.29: bounded, anonymous reads of merchant template assets.
 * CDN response-header policy must still supply correct CORS headers. This
 * reader supports the fixed public resolver and CDN; it never uses no-cors,
 * arbitrary proxy targets, private object paths or credentials. */
(function (window) {
  'use strict';
  if (window.GIOPublicResource) return;
  function failure(code, message) { var e = new Error(message); e.code = code; return e; }
  async function read(url, options) {
    options = options || {};
    var parsed = new URL(url), maximum = Number(options.maximum) || 2097152;
    var publicAsset = parsed.origin === 'https://static.giftinone.com' && /^\/backimg\/(?:gio-templates\/(?:designs|universal|profiles)|gio-layered\/(?:assets|compositions))\/[a-zA-Z0-9._/-]+$/.test(parsed.pathname);
    var publicResolver = parsed.origin === 'https://gpdycx7mqwspis65gnxrnwy3a40lmyzw.lambda-url.us-west-1.on.aws' && /^\/public\/template-resolve\/[a-z][a-z0-9]*(?:-[a-z0-9]+)*$/.test(parsed.pathname) && parsed.pathname.slice('/public/template-resolve/'.length).length <= 80;
    if ((!publicAsset && !publicResolver) || parsed.username || parsed.password || parsed.search || parsed.hash) throw failure('RESOURCE_PATH_INVALID', 'The design resource path is invalid.');
    var budget = Math.min(15000, Number(options.timeoutMs) || 15000, options.deadline ? options.deadline - Date.now() : 15000);
    if (budget <= 0) throw failure('RESOURCE_TIMEOUT', 'The design took too long to load. You can still order for manual review.');
    var controller = new AbortController(), reader = null, expired = false, timer;
    function stop() { try { controller.abort(); } catch (_) {} if (reader) { try { Promise.resolve(reader.cancel()).catch(function () {}); } catch (_) {} } }
    var timeout = new Promise(function (_, reject) { timer = window.setTimeout(function () { expired = true; stop(); reject(failure('RESOURCE_TIMEOUT', 'The design took too long to load. You can still order for manual review.')); }, budget); });
    var task = (async function () {
      for (var attempt = 0; attempt < 2; attempt += 1) {
        try {
          var response = await window.fetch(parsed.href, { method: 'GET', mode: 'cors', credentials: 'omit', redirect: 'error', cache: 'no-store', signal: controller.signal });
          if (expired) throw failure('RESOURCE_TIMEOUT', 'The design took too long to load.');
          if (!response.ok) {
            if (response.body && response.body.cancel) { try { Promise.resolve(response.body.cancel()).catch(function () {}); } catch (_) {} }
            if (response.status >= 500 && attempt === 0) continue;
            return { ok: false, status: response.status, bytes: new Uint8Array(0) };
          }
          if (Number(response.headers.get('Content-Length')) > maximum) throw failure('RESOURCE_SIZE_INVALID', 'The selected design resource exceeds its limit.');
          var bytes;
          if (response.body && response.body.getReader) {
            reader = response.body.getReader(); var parts = [], size = 0;
            while (true) {
              var part = await reader.read();
              if (expired) throw failure('RESOURCE_TIMEOUT', 'The design took too long to load.');
              if (part.done) break;
              size += part.value.byteLength;
              if (size > maximum) throw failure('RESOURCE_SIZE_INVALID', 'The selected design resource exceeds its limit.');
              parts.push(part.value);
            }
            reader = null; bytes = new Uint8Array(size); var offset = 0;
            parts.forEach(function (part) { bytes.set(part, offset); offset += part.byteLength; });
          } else bytes = new Uint8Array(await response.arrayBuffer());
          if (expired) throw failure('RESOURCE_TIMEOUT', 'The design took too long to load.');
          if (!bytes.byteLength || bytes.byteLength > maximum) throw failure('RESOURCE_SIZE_INVALID', 'The selected design resource exceeds its limit.');
          return { ok: true, status: response.status, bytes: bytes };
        } catch (error) {
          if (expired || error && error.code || attempt > 0) throw error;
          // One network retry shares the original hard deadline. It cannot
          // repair an incorrect cached CORS header; deployment fixes that.
          if (reader) { try { Promise.resolve(reader.cancel()).catch(function () {}); } catch (_) {} reader = null; }
        }
      }
    }());
    try { return await Promise.race([task, timeout]); }
    finally { window.clearTimeout(timer); stop(); }
  }
  window.GIOPublicResource = { version: '2.14.29', read: read };
}(window));
